import {
  Group,
  Navbar,
  Stack,
  Text,
  createStyles,
  rem,
  useMantineTheme,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "src/redux/redux-store/hooks";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import useViewportHeight from "src/hooks/useViewPortHeight";
import { FONT_SIZES } from "src/utils/styles";
import { FocusButton } from "./common/Buttons/FocusButton";
import { adminRoutes } from "src/navigators/routes/AdminRoutes";
import { IconName } from "./common/Icons/Icons/iconRegistry";
import useResponsive from "src/hooks/useResponsive";

interface SideBarProps {
  opened: boolean;
  closeNavBar: () => void;
}

const useStyles = createStyles((theme) => ({
  parentContainer: {
    display: "flex", // Makes the navbar a flex container
    flexDirection: "column", // Stacks children vertically
    justifyContent: "center", // Centers children vertically in the container
    backgroundColor: theme.colorScheme == "dark" ? "black" : "white",
  },
  navbar: {
    paddingTop: 10,
    display: "flex", // Makes the navbar a flex container
    flexDirection: "column",
    "@media (min-width: 1024px)": {
      height: "98%",
      borderRadius: "0 0 0 0",
    },
    height: "100%",
    backgroundColor: theme.colorScheme == "dark" ? "black" : theme.white,
  },
  navbarFooter: {
    "@media (max-width: 767px)": {},
  },
  button: {
    borderRadius: "0.25rem",
    fontSize: "0.75rem",
    height: rem(30),
    borderWidth: 0.5,
  },
}));

export enum buttonKeys {
  userManagement = "userManagement",
  dashboard = "dashboard",
  payments = "payments",
  pricing = "pricing",
  complaintCenter = "complaintCenter",
  configureLLM = "configureLLM",
  chatSettings = "chatSettings",
  otherSettings = "otherSettings",
  manageKnowledgebase = "manageKnowledgebase",
  documentUploads = "documentUploads",
}

const SidebarAdmin = (props: SideBarProps) => {
  const { opened, closeNavBar } = props;
  const dispatch = useAppDispatch();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  useViewportHeight();

  const tabActive = (key: string) => {
    return location.pathname.includes(key);
  };

  const onHandleButtonPress = (key: buttonKeys) => {
    closeNavBar();
    switch (key) {
      case buttonKeys.complaintCenter:
        navigate("admin/" + adminRoutes.COMPLAINT_CENTER);
        return;
      case buttonKeys.configureLLM:
        navigate("admin/" + adminRoutes.CONFIGURE_LLM);
        return;
      case buttonKeys.payments:
        navigate("admin/" + adminRoutes.PAYMENTS);
        return;
      case buttonKeys.pricing:
        navigate("admin/" + adminRoutes.PRICING);
        return;
      case buttonKeys.userManagement:
        navigate("admin/" + adminRoutes.USER_MANAGEMENT);
        return;
      case buttonKeys.otherSettings:
        navigate("admin/" + adminRoutes.OTHER_SETTINGS);
        return;
      case buttonKeys.chatSettings:
        navigate("admin/" + adminRoutes.CHAT_SETTINGS);
        return;
      case buttonKeys.manageKnowledgebase:
        navigate("admin/" + adminRoutes.MANAGE_KNOWLEDGEBASE);
        return;
      case buttonKeys.documentUploads:
        navigate("admin/" + adminRoutes.DOCUMENT_UPLOADS);
        return;
      default:
        return;
    }
  };

  const buttons: { icon: IconName; label: string; key: buttonKeys }[] = [
    { key: buttonKeys.userManagement, label: "User Management", icon: "user" },
    { key: buttonKeys.pricing, label: "Pricing", icon: "pricing" },
    {
      key: buttonKeys.complaintCenter,
      label: "Complaint Center",
      icon: "home",
    },
    { key: buttonKeys.configureLLM, label: "Configure LLM", icon: "settings2" },
    {
      key: buttonKeys.payments,
      label: "Subscription Management",
      icon: "info",
    },
    // { key: buttonKeys.chatSettings, label: "Chat Settings", icon: "message" },
    {
      key: buttonKeys.otherSettings,
      label: "Other Settings",
      icon: "threeDots",
    },
    {
      key: buttonKeys.manageKnowledgebase,
      label: "Manage Knowledge Base",
      icon: "knowledgebase",
    },
    {
      key: buttonKeys.documentUploads,
      label: "Document Uploads",
      icon: "upload",
    },
    // More buttons can be added here
  ];

  return (
    <Navbar
      hiddenBreakpoint={992}
      px={"xs"}
      className={classes.parentContainer}
      hidden={!opened}
      width={{
        md: 350,

        base: 250,
      }}
    >
      <div className={classes.navbar}>
        <Text fw={600} size={isMobile ? "1.2rem" : "1.4rem"}>
          Admin Portal
        </Text>
        <Stack w={"100%"} mt={"lg"} spacing="md">
          {buttons.map((button) => (
            <div className="w-full" key={button.key}>
              <FocusButton
                icon={button.icon}
                text={button.label}
                focused={tabActive(button.key)}
                onClick={() => onHandleButtonPress(button.key)}
              />
            </div>
          ))}
        </Stack>
        {/* <SidebarTopSection name={user.name} title="Admin Portal" />   */}
        {/* <div className=" mt-4"><IconButton onClick={handleClearChat} icon="clear" text={"Clear Chat"} /></div> */}
        {/* <SidebarBottomSection chats={dummyChatHistory}/>       */}
      </div>
    </Navbar>
  );
};

export default SidebarAdmin;
